import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { Navigate, Route, Routes } from 'react-router-dom';

import AppTabs from '../../../components/designe/app-tabs/AppTabs';
import { notificationsBasePath } from './notificationsBasePath';
import { NotificationTemplatesList } from './templates/NotificationTemplatesList';
import { NotificationTemplateDetail } from './templates/NotificationTemplateDetail';
import { NotificationCampaignsList } from './campaigns/NotificationCampaignsList';
import { NotificationCampaignForm } from './campaigns/NotificationCampaignForm';
import { NotificationDispatchPage } from './dispatch/NotificationDispatchPage';

export function NotificationsInnerTabs() {
  const { t } = useTranslation();
  const base = notificationsBasePath;

  const tabsConfig = useMemo(
    () => [
      {
        label: t('adminDashboard.notifications.tabs.templates'),
        path: `${base}/templates`,
      },
      {
        label: t('adminDashboard.notifications.tabs.campaigns'),
        path: `${base}/campaigns`,
      },
      {
        label: t('adminDashboard.notifications.tabs.dispatch'),
        path: `${base}/dispatch`,
      },
    ],
    [base, t],
  );

  return (
    <>
      <AppTabs config={tabsConfig} />
      <Box sx={{ mt: 2 }}>
        <Routes>
          <Route
            path="templates/:templateId"
            element={<NotificationTemplateDetail />}
          />
          <Route path="templates" element={<NotificationTemplatesList />} />
          <Route path="campaigns/new" element={<NotificationCampaignForm />} />
          <Route
            path="campaigns/:campaignId"
            element={<NotificationCampaignForm />}
          />
          <Route path="campaigns" element={<NotificationCampaignsList />} />
          <Route path="dispatch" element={<NotificationDispatchPage />} />
          <Route index element={<Navigate to="templates" replace />} />
        </Routes>
      </Box>
    </>
  );
}
